export default __webpack_public_path__ + "static/media/USUARIO_FINAL_CARACTERISTICAS_IMG.ae38a078.png";